import { useState, useEffect } from 'react';
import { getFuncionariosResumo, getDepartamentos, getJornadasExtra, createJornadaExtra, deleteJornadaExtra } from '../services/api';

const hoje = () => new Date().toISOString().slice(0, 10);
const isoToBR = iso => { if (!iso) return ''; if (iso.includes('/')) return iso; const [y,m,d] = iso.split('-'); return `${d}/${m}/${y}`; };
const DIAS = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];
const MESES_CURTO = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
function toISO(s) { if (!s) return ''; if (s.includes('/')) { const [d,m,y] = s.split('/'); return `${y}-${m}-${d}`; } return s; }
function diaSemana(iso) { if (!iso) return ''; const dt = new Date(toISO(iso) + 'T00:00:00'); return isNaN(dt.getTime()) ? '' : DIAS[dt.getDay()]; }
function iniciais(nome) { return nome.split(' ').filter(Boolean).slice(0,2).map(p => p[0]).join('').toUpperCase(); }
function corAvatar(nome) {
  const cores = ['#4f46e5','#0891b2','#059669','#d97706','#dc2626','#7c3aed','#0369a1','#b45309'];
  let h = 0; for (let c of nome) h = (h * 31 + c.charCodeAt(0)) % cores.length;
  return cores[h];
}
function formatDataCard(iso) {
  if (!iso) return { dia: '--', mes: '---', semana: '---' };
  // Aceita YYYY-MM-DD ou DD/MM/YYYY
  let s = iso;
  if (iso.includes('/')) { const [d,m,y] = iso.split('/'); s = `${y}-${m}-${d}`; }
  const dt = new Date(s + 'T00:00:00');
  if (isNaN(dt.getTime())) return { dia: '--', mes: '---', semana: '---' };
  return { dia: String(dt.getDate()).padStart(2,'0'), mes: MESES_CURTO[dt.getMonth()], semana: DIAS[dt.getDay()].substring(0,3) };
}

export default function JornadaExtra() {
  const [funcionarios, setFuncionarios] = useState([]);
  const [registros, setRegistros]       = useState([]);
  const [loading, setLoading]           = useState(false);
  const [salvando, setSalvando]         = useState(false);
  const [erro, setErro]                 = useState('');
  const [sucesso, setSucesso]           = useState('');
  const [busca, setBusca]               = useState('');
  const [departamentos, setDepartamentos] = useState([]);
  const [filtroDept, setFiltroDept]     = useState('');
  const [data, setData]                   = useState(hoje());
  const [tipo, setTipo]                   = useState('hora_extra'); // 'hora_extra' | 'compensacao'
  const [horasJornada, setHorasJornada]   = useState(8);
  const [dataCompensada, setDataCompensada] = useState('');
  const [selecionados, setSelecionados]   = useState([]);
  const [observacao, setObservacao]       = useState('');

  useEffect(() => {
    getFuncionariosResumo().then(r => setFuncionarios(r.data)).catch(() => {});
    getDepartamentos({ ativo: true }).then(r => setDepartamentos(r.data.results || r.data)).catch(() => {});
    carregar();
  }, []); // eslint-disable-line

  async function carregar() {
    setLoading(true);
    try { const r = await getJornadasExtra(); setRegistros(r.data.results || r.data); }
    catch { setRegistros([]); } finally { setLoading(false); }
  }

  function toggleFuncionario(id) {
    setSelecionados(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }

  async function handleSalvar() {
    setErro(''); setSucesso('');
    if (!data) return setErro('Informe a data.');
    if (tipo === 'compensacao' && !dataCompensada) return setErro('Informe a data a ser compensada.');
    if (selecionados.length === 0) return setErro('Selecione ao menos um funcionário.');
    setSalvando(true);
    try {
      await createJornadaExtra({ data, tipo, horas_jornada: horasJornada, data_compensada: tipo === 'compensacao' ? dataCompensada : null, funcionarios: selecionados, observacao });
      setSucesso('Registrado com sucesso.');
      setSelecionados([]); setObservacao(''); setData(hoje()); setTipo('hora_extra'); setHorasJornada(8); setDataCompensada(''); setBusca('');
      setTimeout(() => setSucesso(''), 3000);
      carregar();
    } catch (e) { setErro(e.response?.data?.detail || 'Erro ao salvar.'); }
    finally { setSalvando(false); }
  }

  async function handleExcluir(id) {
    if (!window.confirm('Excluir este registro?')) return;
    try { await deleteJornadaExtra(id); setRegistros(prev => prev.filter(r => r.id !== id)); }
    catch { setErro('Erro ao excluir.'); }
  }

  const funcFiltrados = funcionarios.filter(f =>
    f.nome.toLowerCase().includes(busca.toLowerCase()) &&
    (!filtroDept || String(f.departamento) === String(filtroDept))
  );

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingBottom:16, marginBottom:24, borderBottom:'1px solid #f1f5f9' }}>
        <div style={{ display:'flex', alignItems:'center' }}>
          <div style={{ width:38, height:38, background:'#fff7ed', border:'1px solid #fed7aa', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', color:'#c2410c', fontSize:'var(--fs-lg)', marginRight:14, flexShrink:0 }}>
            <i className="bi bi-calendar2-plus" />
          </div>
          <div>
            <div style={{ fontSize:'var(--fs-2xs)', fontWeight:600, color:'var(--text-subtle)', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:3 }}>Cadastros · Controle de Ponto</div>
            <div style={{ fontSize:'1.3rem', fontWeight:700, color:'var(--text-secondary)', letterSpacing:'-0.5px', lineHeight:1.2 }}>Jornada Extra</div>
          </div>
        </div>
        {registros.length > 0 && (
          <div style={{ background:'#fff7ed', border:'1px solid #fed7aa', borderRadius:20, padding:'3px 12px', fontSize:'var(--fs-xs)', color:'#c2410c', fontWeight:700 }}>
            {registros.length} registro{registros.length !== 1 ? 's' : ''}
          </div>
        )}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 380px', gap:20, alignItems:'start' }}>

        {/* ── Coluna esquerda: Formulário ── */}
        <div>
          {/* Linha: Data + Tipo + Observação */}
          <div style={{ background:'#fff', borderRadius:14, border:'1px solid #e2e8f0', boxShadow:'0 1px 6px rgba(0,0,0,0.05)', marginBottom:16, padding:'16px 20px' }}>
            {/* Linha 1: Data + Tipo + Horas */}
            <div style={{ display:'grid', gridTemplateColumns:'170px auto auto', gap:12, alignItems:'end', marginBottom:12 }}>

              {/* Data */}
              <div>
                <label className="form-label">Data</label>
                <input
                  type="date"
                  value={data}
                  onChange={e => setData(e.target.value)}
                  className="form-control form-control-sm"
                  style={{ fontWeight:600 }}
                />
                {data && <div style={{ fontSize:'var(--fs-2xs)', color:'var(--text-subtle)', marginTop:4 }}><i className="bi bi-calendar3 me-1" />{diaSemana(data)}, {isoToBR(data)}</div>}
              </div>

              {/* Tipo — toggle */}
              <div>
                <label className="form-label">Tipo</label>
                <div style={{ display:'flex', borderRadius:8, overflow:'hidden', border:'1px solid #e2e8f0' }}>
                  {[
                    { v:'hora_extra',  icon:'bi-lightning-charge-fill', label:'Hora Extra',  bg:'#fff7ed', color:'#c2410c' },
                    { v:'compensacao', icon:'bi-arrow-repeat',           label:'Compensação', bg:'#eff6ff', color:'#1d4ed8' },
                  ].map(op => (
                    <button
                      key={op.v}
                      onClick={() => setTipo(op.v)}
                      style={{
                        flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:5,
                        padding:'6px 14px', border:'none', cursor:'pointer', fontSize:'var(--fs-xs)', fontWeight:700,
                        background: tipo === op.v ? op.bg : '#f8fafc',
                        color: tipo === op.v ? op.color : '#94a3b8',
                        borderRight: op.v === 'hora_extra' ? '1px solid #e2e8f0' : 'none',
                        transition:'all 0.15s',
                      }}
                    >
                      <i className={`bi ${op.icon}`} />
                      {op.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Horas da jornada */}
              <div>
                <label className="form-label">Horas da Jornada</label>
                <div style={{ display:'flex', borderRadius:8, overflow:'hidden', border:'1px solid #e2e8f0' }}>
                  {[8, 9].map(h => (
                    <button
                      key={h}
                      onClick={() => setHorasJornada(h)}
                      style={{
                        flex:1, padding:'6px 0', border:'none', cursor:'pointer', fontSize:'var(--fs-sm)', fontWeight:700,
                        background: horasJornada === h ? '#f0fdf4' : '#f8fafc',
                        color: horasJornada === h ? '#15803d' : '#94a3b8',
                        borderRight: h === 8 ? '1px solid #e2e8f0' : 'none',
                        transition:'all 0.15s',
                      }}
                    >
                      {h}h
                    </button>
                  ))}
                </div>
                <div style={{ fontSize:'var(--fs-2xs)', color:'var(--text-subtle)', marginTop:4 }}>
                  {tipo === 'hora_extra'
                    ? 'Ideal: 8–9h · max 10h extras contabilizadas'
                    : `Deve cumprir ${horasJornada}h (igual ao dia compensado)`}
                </div>
              </div>

            </div>

            {/* Linha 2: Data compensada (só compensação) + Observação */}
            <div style={{ display:'grid', gridTemplateColumns: tipo === 'compensacao' ? '200px 1fr' : '1fr', gap:12, alignItems:'end' }}>

              {tipo === 'compensacao' && (
                <div>
                  <label className="form-label" style={{ color:'#1d4ed8' }}>
                    <i className="bi bi-calendar-x me-1" />Data a Compensar
                  </label>
                  <input
                    type="date"
                    value={dataCompensada}
                    onChange={e => setDataCompensada(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ fontWeight:600, borderColor:'#bfdbfe' }}
                  />
                  {dataCompensada && (
                    <div style={{ fontSize:'var(--fs-2xs)', color:'#1d4ed8', marginTop:4 }}>
                      <i className="bi bi-arrow-return-right me-1" />Compensando: {diaSemana(dataCompensada)}, {isoToBR(dataCompensada)}
                    </div>
                  )}
                </div>
              )}

              <div>
                <label className="form-label">Observação</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Motivo ou contexto..."
                  value={observacao}
                  onChange={e => setObservacao(e.target.value)}
                />
              </div>
            </div>

            {/* Aviso VR (hora_extra) */}
            {tipo === 'hora_extra' && (
              <div style={{ marginTop:10, background:'#fffbeb', border:'1px solid #fde68a', borderRadius:8, padding:'6px 12px', fontSize:'var(--fs-xs)', color:'#92400e', display:'flex', gap:8 }}>
                <i className="bi bi-info-circle-fill" style={{ flexShrink:0, marginTop:1 }} />
                <span>
                  <strong>Regras hora extra:</strong> jornada de {horasJornada}h gera horas para banco.
                  Se trabalhar menos de 6h → VR pela metade. Máximo de 10h extras contabilizadas por dia.
                </span>
              </div>
            )}
            {tipo === 'compensacao' && (
              <div style={{ marginTop:10, background:'#eff6ff', border:'1px solid #bfdbfe', borderRadius:8, padding:'6px 12px', fontSize:'var(--fs-xs)', color:'#1e40af', display:'flex', gap:8 }}>
                <i className="bi bi-info-circle-fill" style={{ flexShrink:0, marginTop:1 }} />
                <span>
                  <strong>Regras compensação:</strong> o funcionário deve cumprir exatamente {horasJornada}h para compensar o dia selecionado.
                </span>
              </div>
            )}
          </div>

          {/* Card seleção de funcionários */}
          <div style={{ background:'#fff', borderRadius:14, border:'1px solid #e2e8f0', boxShadow:'0 1px 6px rgba(0,0,0,0.05)', overflow:'hidden' }}>
            {/* Header */}
            <div style={{ padding:'14px 20px', borderBottom:'1px solid #f1f5f9', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <i className="bi bi-people-fill" style={{ color:'#c2410c', fontSize:'0.95rem' }} />
                <span style={{ fontWeight:700, fontSize:'var(--fs-base)', color:'#1e293b' }}>Funcionários</span>
                {selecionados.length > 0 && (
                  <span style={{ background:'#c2410c', color:'#fff', borderRadius:20, padding:'1px 10px', fontSize:'var(--fs-xs)', fontWeight:700 }}>
                    {selecionados.length}
                  </span>
                )}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button className="btn-secondary-custom" style={{ color:'#1d4ed8', borderColor:'#bfdbfe' }} onClick={() => setSelecionados(funcionarios.map(f => f.id))}>
                  Todos
                </button>
                <button className="btn-secondary-custom" onClick={() => setSelecionados([])}>
                  Limpar
                </button>
              </div>
            </div>

            {/* Busca + Filtro de setor */}
            <div style={{ padding:'10px 20px', borderBottom:'1px solid #f8fafc', display:'flex', gap:8 }}>
              <div style={{ position:'relative', flex:1 }}>
                <i className="bi bi-search" style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', color:'#cbd5e1', fontSize:'var(--fs-xs)' }} />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar funcionário..."
                  value={busca}
                  onChange={e => setBusca(e.target.value)}
                  style={{ paddingLeft:30, borderRadius:8, fontSize:'var(--fs-sm)' }}
                />
              </div>
              <select
                className="form-select form-select-sm"
                value={filtroDept}
                onChange={e => setFiltroDept(e.target.value)}
                style={{ minWidth:160, borderRadius:8, fontSize:'var(--fs-sm)', color: filtroDept ? '#c2410c' : undefined, fontWeight: filtroDept ? 600 : undefined }}
              >
                <option value="">Todos os setores</option>
                {departamentos.map(d => (
                  <option key={d.id} value={d.id}>{d.nome}</option>
                ))}
              </select>
            </div>

            {/* Grid de funcionários com avatar */}
            <div style={{ padding:'12px 16px', display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(210px, 1fr))', gap:6, maxHeight:260, overflowY:'auto' }}>
              {funcFiltrados.map(f => {
                const sel = selecionados.includes(f.id);
                const cor = corAvatar(f.nome);
                return (
                  <button
                    key={f.id}
                    onClick={() => toggleFuncionario(f.id)}
                    style={{
                      display:'flex', alignItems:'center', gap:9,
                      background: sel ? '#fff7ed' : '#f8fafc',
                      border: `1.5px solid ${sel ? '#fed7aa' : '#e2e8f0'}`,
                      borderRadius:10, padding:'7px 10px',
                      cursor:'pointer', textAlign:'left',
                      transition:'all 0.12s',
                      boxShadow: sel ? '0 0 0 2px rgba(194,65,12,0.12)' : 'none',
                    }}
                  >
                    <div style={{ width:28, height:28, borderRadius:'50%', background: sel ? '#c2410c' : cor, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontSize:'var(--fs-2xs)', fontWeight:800, color:'#fff', transition:'background 0.12s' }}>
                      {sel ? <i className="bi bi-check2" style={{ fontSize:'var(--fs-base)' }} /> : iniciais(f.nome)}
                    </div>
                    <span style={{ fontSize:'var(--fs-xs)', fontWeight:600, color: sel ? '#c2410c' : '#475569', lineHeight:1.3, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>
                      {f.nome}
                    </span>
                  </button>
                );
              })}
              {funcFiltrados.length === 0 && (
                <div style={{ gridColumn:'1/-1', textAlign:'center', padding:'20px 0', color:'var(--text-subtle)', fontSize:'var(--fs-sm)' }}>
                  Nenhum funcionário encontrado.
                </div>
              )}
            </div>

            {/* Footer com botão salvar */}
            <div style={{ padding:'14px 20px', borderTop:'1px solid #f1f5f9', display:'flex', alignItems:'center', justifyContent:'space-between', background:'#fafafa' }}>
              <div style={{ fontSize:'var(--fs-xs)', color:'var(--text-subtle)' }}>
                {selecionados.length > 0
                  ? <span style={{ color:'#c2410c', fontWeight:600 }}>{selecionados.length} funcionário{selecionados.length !== 1 ? 's' : ''} selecionado{selecionados.length !== 1 ? 's' : ''}</span>
                  : 'Nenhum selecionado'}
              </div>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                {erro    && <span style={{ fontSize:'var(--fs-xs)', color:'#dc2626', fontWeight:600 }}><i className="bi bi-exclamation-circle me-1" />{erro}</span>}
                {sucesso && <span style={{ fontSize:'var(--fs-xs)', color:'#16a34a', fontWeight:600 }}><i className="bi bi-check-circle me-1" />{sucesso}</span>}
                <button
                  className="btn-primary-custom"
                  onClick={handleSalvar}
                  disabled={salvando}
                  style={{ background: salvando ? '#fed7aa' : 'linear-gradient(135deg,#c2410c,#ea580c)', borderColor:'transparent', boxShadow:'0 2px 8px rgba(194,65,12,0.3)' }}
                >
                  {salvando ? <><span className="spinner-border spinner-border-sm" />Salvando...</> : <><i className="bi bi-floppy2-fill" />Salvar</>}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── Coluna direita: Registros ── */}
        <div style={{ background:'#fff', borderRadius:14, border:'1px solid #e2e8f0', boxShadow:'0 1px 6px rgba(0,0,0,0.05)', overflow:'hidden', position:'sticky', top:16 }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #f1f5f9', display:'flex', alignItems:'center', gap:8 }}>
            <i className="bi bi-clock-history" style={{ color:'#c2410c', fontSize:'0.9rem' }} />
            <span style={{ fontWeight:700, fontSize:'var(--fs-base)', color:'#1e293b' }}>Histórico</span>
          </div>

          {loading && (
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center', padding:'48px 0' }}>
              <span className="spinner-border spinner-border-sm text-warning me-2" />
              <span style={{ fontSize:'var(--fs-sm)', color:'var(--text-subtle)' }}>Carregando...</span>
            </div>
          )}

          {!loading && registros.length === 0 && (
            <div style={{ textAlign:'center', padding:'48px 20px' }}>
              <div style={{ width:56, height:56, background:'#fff7ed', border:'1px solid #fed7aa', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                <i className="bi bi-calendar2-x" style={{ fontSize:'1.5rem', color:'#fed7aa' }} />
              </div>
              <p style={{ fontWeight:600, fontSize:'var(--fs-base)', color:'var(--text-subtle)', marginBottom:4 }}>Nenhum registro ainda</p>
              <p style={{ fontSize:'var(--fs-xs)', color:'#cbd5e1' }}>Os registros aparecerão aqui.</p>
            </div>
          )}

          {!loading && registros.length > 0 && (
            <div style={{ maxHeight:620, overflowY:'auto' }}>
              {registros.map((reg, i) => {
                const dc = formatDataCard(reg.data);
                const nomes = reg.funcionarios_nomes || [];
                return (
                  <div key={reg.id} style={{ padding:'14px 18px', borderBottom: i < registros.length - 1 ? '1px solid #f8fafc' : 'none', display:'flex', gap:12 }}>
                    {/* Mini data */}
                    <div style={{ background:'linear-gradient(135deg,#fff7ed,#ffedd5)', border:'1px solid #fed7aa', borderRadius:10, padding:'6px 10px', textAlign:'center', minWidth:48, flexShrink:0 }}>
                      <div style={{ fontSize:'0.55rem', fontWeight:700, color:'#c2410c', textTransform:'uppercase' }}>{dc.semana}</div>
                      <div style={{ fontSize:'1.3rem', fontWeight:800, color:'#c2410c', lineHeight:1 }}>{dc.dia}</div>
                      <div style={{ fontSize:'0.55rem', fontWeight:700, color:'#ea580c', textTransform:'uppercase' }}>{dc.mes}</div>
                    </div>

                    {/* Conteúdo */}
                    <div style={{ flex:1, minWidth:0 }}>
                      {/* Badge tipo + horas */}
                      <div style={{ display:'flex', gap:5, marginBottom:5, flexWrap:'wrap' }}>
                        <span style={{
                          fontSize:'var(--fs-2xs)', fontWeight:700, borderRadius:10, padding:'1px 8px',
                          background: reg.tipo === 'hora_extra' ? '#fff7ed' : '#eff6ff',
                          color: reg.tipo === 'hora_extra' ? '#c2410c' : '#1d4ed8',
                          border: `1px solid ${reg.tipo === 'hora_extra' ? '#fed7aa' : '#bfdbfe'}`,
                        }}>
                          <i className={`bi ${reg.tipo === 'hora_extra' ? 'bi-lightning-charge-fill' : 'bi-arrow-repeat'} me-1`} />
                          {reg.tipo === 'hora_extra' ? 'Hora Extra' : 'Compensação'}
                        </span>
                        <span style={{ fontSize:'var(--fs-2xs)', fontWeight:700, borderRadius:10, padding:'1px 8px', background:'#f0fdf4', color:'#15803d', border:'1px solid #bbf7d0' }}>
                          <i className="bi bi-clock me-1" />{reg.horas_jornada || 8}h
                        </span>
                        {reg.tipo === 'compensacao' && reg.data_compensada && (
                          <span style={{ fontSize:'var(--fs-2xs)', fontWeight:600, borderRadius:10, padding:'1px 8px', background:'#f8fafc', color:'#475569', border:'1px solid #e2e8f0' }}>
                            <i className="bi bi-calendar-x me-1" />{isoToBR(reg.data_compensada)}
                          </span>
                        )}
                      </div>
                      {/* Avatares */}
                      <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom: reg.observacao ? 6 : 0 }}>
                        {nomes.slice(0, 6).map((nome, idx) => (
                          <div key={idx} style={{ display:'flex', alignItems:'center', gap:4, background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:20, padding:'2px 8px' }}>
                            <div style={{ width:16, height:16, borderRadius:'50%', background: corAvatar(nome), display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.48rem', fontWeight:800, color:'#fff', flexShrink:0 }}>
                              {iniciais(nome)}
                            </div>
                            <span style={{ fontSize:'var(--fs-2xs)', fontWeight:600, color:'#475569', whiteSpace:'nowrap' }}>{nome.split(' ')[0]}</span>
                          </div>
                        ))}
                        {nomes.length > 6 && (
                          <div style={{ background:'#f1f5f9', border:'1px solid #e2e8f0', borderRadius:20, padding:'2px 8px', fontSize:'var(--fs-2xs)', color:'var(--text-muted)', fontWeight:600 }}>
                            +{nomes.length - 6}
                          </div>
                        )}
                      </div>
                      {reg.observacao && (
                        <div style={{ fontSize:'var(--fs-xs)', color:'var(--text-subtle)', fontStyle:'italic', marginTop:4, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                          <i className="bi bi-chat-left-text me-1" style={{ opacity:0.6 }} />{reg.observacao}
                        </div>
                      )}
                      <div style={{ fontSize:'var(--fs-2xs)', color:'#cbd5e1', marginTop:4 }}>{nomes.length} funcionário{nomes.length !== 1 ? 's' : ''}</div>
                    </div>

                    {/* Excluir */}
                    <button
                      className="btn-icon"
                      onClick={() => handleExcluir(reg.id)}
                      style={{ color:'#dc2626', alignSelf:'flex-start', flexShrink:0 }}
                      title="Excluir"
                    >
                      <i className="bi bi-trash3" />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
